const MFA_RESEND_COOLDOWN_SECONDS_FALLBACK = 20;
const MILLISECONDS_PER_SECOND = 1000;
const FALLBACK_COOLDOWN_MS = MFA_RESEND_COOLDOWN_SECONDS_FALLBACK * MILLISECONDS_PER_SECOND;

const buildFallbackCooldownEndMs = (clientNowMs: number): number =>
  clientNowMs + FALLBACK_COOLDOWN_MS;

export const resolveCooldownEndsAtMs = (nextResendAvailableAt: string | undefined): number => {
  const clientNowMs = Date.now();
  if (!nextResendAvailableAt) {
    return buildFallbackCooldownEndMs(clientNowMs);
  }
  const cooldownEndUtcMs = new Date(nextResendAvailableAt).getTime();
  if (Number.isNaN(cooldownEndUtcMs)) {
    return buildFallbackCooldownEndMs(clientNowMs);
  }
  return cooldownEndUtcMs;
};
